/**
 * Query to get all news categories
 * @returns string
 */
export const getNewsCategoriesQuery = () =>
  'query{ swishNewsCategoriesCollection(order:sortOrder_ASC, where:{categoryName_not_in : "Story"}){ items { categoryName sortOrder icon { url } }}}';

/**
 * Query to fetch all details of a news article by id
 * @param id news id
 * @returns string
 */
export const getNewsDetailQuery = (id: string) =>
  `query{ swishNewsContentful(id:"${id}") { sys { id } headline summary fullContent contentSegmentList sourceUrl showReadMore outlet { outletName logo { url } website } images categories publishedDate tags }}`;

/**
 * Query to fetch all related news articles
 * @param category  news category
 * @param tags news tags
 * @param limit number of articles to fetch
 * @returns string
 */
export const getRelatedNewsQuery = (category: string, tags: string[] = [], limit = 4) => {
  if (tags.length > 0) {
    const tagsQuery = JSON.stringify(tags);
    return `query { swishNewsContentfulCollection( order: [publishedDate_DESC] where: { AND: [ {type_in: ["Image", "Video"]} {categories_contains_some: "${category}"} ] OR: [ {curatedOrgTags_contains_some: ${tagsQuery}} ] } limit: ${limit} ) { total items { sys { id } headline summary sourceUrl outlet { outletName logo { url } website } images categories publishedDate tags } }}`;
  }
  return `query { swishNewsContentfulCollection( order: [publishedDate_DESC] where: { AND: [ {type_in: ["Image", "Video"]} {categories_contains_some: "${category}"} ] } limit: ${limit} ) { total items { sys { id } headline summary sourceUrl outlet { outletName logo { url } website } images categories publishedDate tags } }}`;
};

/**
 * Query to get all video news
 * @param skip number of skip
 * @param limit number of videos to fetch
 * @returns string
 */
export const getVideoNewsQuery = (skip = 0, limit = 20) =>
  `query {swishNewsContentfulCollection(order: publishedDate_DESC where: { type_in:"Video" } limit: ${limit}, skip:${skip}  ){items { sys { id } headline fullContent sourceUrl showReadMore images storyVideo categories publishedDate outlet { outletName logo { url } website }}}}`;
